@if (hasCosmetics()) {
  <div class="flex flex-col gap-4">
    <div class="flex justify-end">
      <p-button
        (onClick)="handleSelectCosmeticsClick()"
        [disabled]="isDisabled()"
        appPrimengButton
        label="Dodaj kosmetyki"
        size="small" />
    </div>

    <app-admin-box-cosmetics-grid
      [items]="cosmetics()"
      [isReadonly]="isDisabled()"
      (removeClickEvent)="handleRemoveCosmeticClick($event)" />
  </div>
} @else {
  <div class="rounded-sm border border-dashed border-gray-300 p-4">
    <div class="mb-3 text-sm text-gray-500 italic">
      Brak powiązanych kosmetyków.
    </div>

    <p-button
      (onClick)="handleSelectCosmeticsClick()"
      [disabled]="isDisabled()"
      [fluid]="true"
      appPrimengButton
      label="Dodaj kosmetyki"
      size="small" />
  </div>
}

@if (cosmeticModalVisible()) {
  <app-admin-box-sale-cosmetic-select-modal
    [excludedIds]="excludedIds()"
    [visible]="cosmeticModalVisible()"
    (cancelEvent)="handleCosmeticModalCancelEvent()"
    (submitEvent)="handleCosmeticModalSubmitEvent($event)" />
}
